import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "@mui/material/Collapse";
import "./style.css";

interface MenuItem {
  id: number;
  title: string;
  link?: string;
  submenu?: MenuItem[];
}

const menus: MenuItem[] = [
  {
    id: 1,
    title: "Home",
    link: "/",
  },

  /* ================= Business Consulting Menu ================= */
  {
    id: 2,
    title: "Business Consulting",
    link: "/business-consulting",
    submenu: [
      { id: 201, title: "Digital Transformation", link: "/digital-transformation" },
      { id: 202, title: "Startup Consulting", link: "/startup-consulting" },
      { id: 203, title: "Product Strategy", link: "/product-strategy" },
      { id: 204, title: "IT Consulting", link: "/it-consulting" },
      { id: 205, title: "Blockchain Consulting", link: "/blockchain-consulting" },
      { id: 206, title: "Growth Strategy", link: "/growth-strategy" },
    ],
  },

  /* ================= Blockchain Menu ================= */
  {
    id: 3,
    title: "Blockchain",
    link: "/blockchain-development",
    submenu: [
      { id: 301, title: "Ecommerce", link: "/ecommerce-blockchain-development" },
      { id: 302, title: "Healthcare", link: "/healthcare-blockchain-development" },
      { id: 303, title: "Transportation", link: "/transportation-blockchain-development" },
      { id: 304, title: "Supply Chain", link: "/supply-chain-blockchain-development" },
      { id: 305, title: "Real Estate", link: "/real-estate-blockchain-development" },
      { id: 306, title: "NFT Marketplace", link: "/nft-marketplace-service" },
      { id: 307, title: "DeFi Solutions", link: "/defi" },
      { id: 308, title: "Smart Contracts", link: "/smart-contract-development" },
      { id: 309, title: "Crypto Wallet", link: "/white-label-wallet" },
      { id: 310, title: "Token Development", link: "/token-development" },
      { id: 311, title: "DAO Development", link: "/dao-development" },
      { id: 312, title: "Metaverse Development", link: "/metaverse-development" },
    ],
  },

  /* ================= Web & App Development Menu ================= */
  {
    id: 4,
    title: "Web & App Development",
    link: "/web-development",
    submenu: [
      { id: 401, title: "Corporate Websites", link: "/corporate-websites" },
      { id: 402, title: "Ecommerce Development", link: "/ecommerce-development" },
      { id: 403, title: "SaaS Platforms", link: "/saas-platforms" },
      { id: 404, title: "CMS Development", link: "/cms-development" },
      { id: 405, title: "Marketplace Development", link: "/marketplace-development" },
      { id: 406, title: "Web Portals", link: "/web-portals" },
      { id: 407, title: "Android Apps", link: "/android-apps" },
      { id: 408, title: "iOS Apps", link: "/ios-apps" },
      { id: 409, title: "Hybrid Apps", link: "/hybrid-apps" },
      { id: 410, title: "Web3 Apps", link: "/web3-apps" },
      { id: 411, title: "On-Demand Apps", link: "/on-demand-apps" },
      { id: 412, title: "Enterprise Apps", link: "/enterprise-apps" },
    ],
  },

  /* ================= Brand Development Menu ================= */
  {
    id: 5,
    title: "Brand Development",
    link: "/brand-development",
    submenu: [
      { id: 501, title: "Logo Design", link: "/logo-design" },
      { id: 502, title: "Brand Identity", link: "/brand-identity" },
      { id: 503, title: "UI / UX Design", link: "/ui-ux-design" },
      { id: 504, title: "Marketing Creatives", link: "/marketing-creatives" },
      { id: 505, title: "Social Media Branding", link: "/social-media-branding" },
      { id: 506, title: "Reputation Management", link: "/reputation-management" },
    ],
  },

  { id: 6, title: "About Us", link: "/about" },
  { id: 7, title: "Contact Us", link: "/contact" },
  { id: 8, title: "Hire Us", link: "/hire-us" },
];

const MobileMenu: React.FC = () => {
  const [openId, setOpenId] = useState<number | null>(null);

  const toggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <ul className="responsivemenu">
      {menus.map((menu) => (
        <li key={menu.id} className={openId === menu.id ? "active" : ""}>
          {menu.submenu ? (
            <Fragment>
              <p onClick={() => toggle(menu.id)}>
                {menu.title}
                <i className={openId === menu.id ? "fa fa-angle-up" : "fa fa-angle-down"}></i>
              </p>

              <Collapse in={openId === menu.id} timeout="auto" unmountOnExit>
                <ul className="subMenu">
                  {menu.submenu.map((sub) => (
                    <li key={sub.id}>
                      <Link to={sub.link!} onClick={handleClick}>
                        {sub.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </Collapse>
            </Fragment>
          ) : (
            <Link to={menu.link!} onClick={handleClick}>
              {menu.title}
            </Link>
          )}
        </li>
      ))}
    </ul>
  );
};

export default MobileMenu;
